import type { MessageBodyMatchesCondition as MessageBodyMatchesConditionType } from "@redotech/redo-model/advanced-flow/rules/schemas";
import { RedoCheckbox } from "@redotech/redo-web/arbiter-components/checkbox/redo-checkbox";
import { RedoTagInputField } from "@redotech/redo-web/arbiter-components/input/redo-tag-input-field";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useState } from "react";

export const MessageBodyMatchesCondition = memo(
  function MessageBodyMatchesCondition({
    condition,
    onChange,
  }: {
    condition: MessageBodyMatchesConditionType;
    onChange: (updated: MessageBodyMatchesConditionType) => void;
  }) {
    const [inputValue, setInputValue] = useState("");

    return (
      <Flex dir="column" gap="md" w="full">
        <RedoTagInputField
          delimiters={["newline"]}
          inputValue={inputValue}
          label="Message body text to match"
          placeholder="Enter message body text to match"
          setInputValue={setInputValue}
          setTags={(queryStrings) => {
            const uniqueStrings = Array.from(new Set(queryStrings));
            onChange({ ...condition, queryStrings: uniqueStrings });
          }}
          state="default"
          tags={(condition.queryStrings || []).map((text) => ({ text }))}
        />
        <RedoCheckbox
          label="Case sensitive"
          setValue={(v) =>
            onChange({ ...condition, caseSensitive: v === true })
          }
          size="sm"
          value={condition.caseSensitive || false}
        />
      </Flex>
    );
  },
);
